import HumanToBotCollectionTask from "./components/human-to-bot-task";

export default HumanToBotCollectionTask;
